export default "__VITE_ASSET__CKLctN6F__"